module.exports = __webpack_public_path__ + "static/media/reactivate.3c717f07.svg";